import React, { useEffect, useState } from 'react'
import { Checkbox, InputAdornment, TextField } from '@mui/material'
import searchIcon from '../../../Assets/Images/FilterSearchIcon.png';

export default function CheckboxFilters({ filter, handleCheckboxChange, checkboxStates }) {
  const [showAll, setShowAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [displayValues, setDisplayValues] = useState(filter.values);
  useEffect(() => {
    if(searchTerm && searchTerm !== ''){
      let newDisplayValues = filter.values.filter(val => (val.label.toLowerCase()).includes(searchTerm.toLowerCase()));
      setDisplayValues(newDisplayValues);
    }
    else{
      setDisplayValues(filter.values);
    }
  }, [searchTerm])
  return (
      <div className='checkbox-list'>
        <p>{filter.title}</p>
        {
          filter.search &&
          <div className='search-box'>
            <TextField InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <img src={searchIcon} alt="firstName" width={20} height={20} />
                </InputAdornment>
              ),
              disableUnderline: true
            }} hiddenLabel placeholder={`Search ${filter.title}`} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} fullWidth variant="standard" size="normal" className="search-field" sx={{ width: "100%", }} />
          </div>
        }
        <div className='checkbox-items'>
          {(filter.search ? (showAll ? displayValues : displayValues.slice(0, 5)) : filter.values).map((item) => (
            <div className='item' key={item.label}>
              <p>{item.label}</p>
              <div className='checkbox-container'>
                <p>{item.number}</p>
                <Checkbox
                  checked={checkboxStates[item.label] || false}
                  onChange={handleCheckboxChange(item.label)}
                  sx={{ padding: 0, margin: 0, '& .MuiSvgIcon-root': { fontSize: 18 } }}
                />
              </div>
            </div>
          ))}
          {filter.search && displayValues.length > 5 && <p onClick={() => setShowAll(showAll => !showAll)} className='bottom-text'>{showAll ? 'HIDE' : 'SHOW ALL'}</p>}
        </div>
      </div>
  )
}
